import http from '../utils/http';
import {
    mutations as baseMutations,
    actions as baseActions
} from './searchBase';

const defaultState = {
    entityName: 'support',
    baseUrl: 'api/documentStore/',
    actionsConfig: {},
    buttonsConfig: {},
    optionsConfig: {},
    documents: {},
    documentsPending: false,
    prefixes: {},
    prefixesPending: false,
    helpUrl: '/user-guide/guide/customer-support.html'
};

export const mutations = {
    ...baseMutations,
    setDocuments(state, value) {
        if (value) {
            state.documents = value;
        } else {
            state.documents = {};
        }
    },
    setDocumentsPending(state, value) {
        if (typeof value === 'boolean') {
            state.documentsPending = value;
        } else {
            state.documentsPending = false;
        }
    },
    setPrefixes(state, value) {
        if (value) {
            state.prefixes = value;
        } else {
            state.prefixes = {};
        }
    },
    setPrefixesPending(state, value) {
        if (typeof value === 'boolean') {
            state.prefixesPending = value;
        } else {
            state.prefixesPending = false;
        }
    }
};

export const actions = {
    ...baseActions,
    fetchDocuments({ commit, state }) {
        console.log('calling fetchDocuments');
        commit('setDocumentsPending', true);
        return http
            .get(state.baseUrl, {
                notifyRequestPending: true
            })
            .then(res => {
                commit('setDocuments', res.data);
            })
            .finally(() => {
                commit('setDocumentsPending', false);
            });
    },
    fetchPrefixes({ commit, state }) {
        console.log('calling fetchDocuments');
        commit('setPrefixesPending', true);
        return http
            .get(`${state.baseUrl}allowablePrefixes`, {
                notifyRequestPending: true
            })
            .then(res => {
                commit('setPrefixes', res.data);
            })
            .finally(() => {
                commit('setPrefixesPending', false);
            });
    },
    fetchDocumentByKey({ state }, { key }) {
        console.log('calling fetchDocumentByKey', key);
        if (key) {
            return http.get(`${state.baseUrl}byKey?key=${key}`, {
                notifyRequestPending: true,
                responseType: 'blob'
            });
        }
    },
    postDocument({ state }, { document, prefix }) {
        console.log('calling postDocument', prefix);
        const data = new FormData();
        data.append('file', document);
        data.append('prefix', prefix);
        return http.post(`${state.baseUrl}`, data, {
            notifyRequestPending: true,
            successMessage: 'File was uploaded successfully',
            contentType: 'multipart/form-data'
        });
    },
    deleteDocument({ state }, { key }) {
        console.log('calling deleteDocument');
        return http.delete(`${state.baseUrl}byKey?key=${key}`, null, {
            notifyRequestPending: true,
            notifySuccess: true,
            notifyError: true,
            successMessage: 'Document has been deleted successfully'
        });
    }
};

export default {
    namespaced: true,
    state: defaultState,
    mutations,
    actions
};
